module.exports = {"320803001":"淮城街道","320803002":"河下街道","320803004":"山阳街道","320803101":"平桥镇","320803104":"朱桥镇","320803106":"施河镇","320803107":"车桥镇","320803109":"流均镇","320803110":"博里镇","320803112":"复兴镇","320803113":"苏嘴镇","320803114":"钦工镇","320803115":"顺河镇","320803121":"漕运镇","320803122":"石塘镇","320803123":"范集镇","320803400":"白马湖农场","320803401":"经济开发区","320803402":"淮安新材料产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320803.json
// module id = 994
// module chunks = 0